import DOMPurify, { type Config } from 'dompurify';

const domPurify = DOMPurify();

// Keep `style` on incoming HTML but restrict it to declarations Tiptap's Color and
// multicolor Highlight marks rely on. Without this, paste round-trips lose text colour
// and highlight colour because both marks serialise to inline style.
domPurify.addHook('uponSanitizeAttribute', (_node, data) => {
  if (data.attrName !== 'style') {
    return;
  }

  const safe = data.attrValue
    .split(';')
    .map((decl) => decl.trim())
    .filter((decl) => /^(color|background-color)\s*:/i.test(decl))
    .join('; ');

  if (safe) {
    data.attrValue = safe;
  } else {
    data.keepAttr = false;
  }
});

const PASTE_CONFIG: Config = {
  USE_PROFILES: { html: true },
  // Drop presentational/identity carriers. Tiptap re-renders structure with its own
  // classes; incoming class/id just adds noise and round-trip risk. `style` is handled
  // by the hook above so colour/highlight marks survive.
  FORBID_ATTR: ['class', 'id'],
  // <font> is deprecated HTML; <style> would otherwise leak CSS rules as visible text.
  FORBID_TAGS: ['style', 'font'],
};

export const sanitizePastedHTML = (html: string): string => {
  if (!html) {
    return html;
  }

  return domPurify.sanitize(html, PASTE_CONFIG) as string;
};
